import React from 'react';
import Amplify from 'aws-amplify';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { connect } from 'react-redux';
import { withAlert } from 'react-alert';
import {
  getSettlemetEnrichmentQuestion, getAllSettlement,
  getEnrollSettlementForUser, getAlLFeatureSettlement,
} from '../../../Actions/actions';
import * as SecretKeys from '../../../ENV.json';
import RegistrationLinks from './registrationLinks';

Amplify.configure(SecretKeys.awsUserpool);

class RegistrationLinkContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: 0,
    };
  }

  scrollStep=() => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  componentWillMount() {
    const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({
      intervalId,
    });
  }

  render() {
    return (
      <div className="container">
        <span />
        <div className="main-content">
          <RegistrationLinks />
        </div>
      </div>
    );
  }
}

RegistrationLinkContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    getSettlemetEnrichmentQuestion,
    getAllSettlement,
    getEnrollSettlementForUser,
    getAlLFeatureSettlement,
  }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(RegistrationLinkContainer));
